import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

import { CookieService } from "ngx-cookie";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import {
  catchError,
  filter,
  finalize,
  map,
  mergeMap,
  switchMap,
  take,
} from "rxjs/operators";
import { handleError } from "../error-handler/handleError";
import { AuthService } from "./auth.service";
import { AppError } from "../error-handler/app-error";
import { Router } from "@angular/router";
import { BlockUI, NgBlockUI } from "ng-block-ui";

@Injectable({
  providedIn: "root",
})
export class Interceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}
  cookieService = inject(CookieService);
  private isRefreshing = false;
    @BlockUI() blockUI: NgBlockUI;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  ExcludedUrls = [

    "/assets",
    "/admin/login",
    "api/PageTemplate/SaveTemplatesSettings",
  ];

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let clonedRequest = this.convertData(req);
    let  finalResponse;
    finalResponse= next.handle(clonedRequest).pipe(
      map((res: HttpEvent<any>) => {
        let resData = this.handleResponse(res)

 return resData
      }),

      catchError((error: HttpErrorResponse) => {
        if (error && error.status === 401) {
          return this.handle401Error(req, next);
        } else {
          this.blockUI.resetGlobal();
          return handleError(error);
        }
      })
    );
   return  finalResponse
  }

  // handle401Error(request: HttpRequest<any>, next: HttpHandler) {
  //     if (!this.isRefreshing) {
  //         this.isRefreshing = true;
  //         this.refreshTokenSubject.next(null);

  //         return this.authService.refreshToken().pipe(
  //             switchMap((token: any) => {
  //                 this.isRefreshing = false;
  //                 this.refreshTokenSubject.next(token);

  //                 let clonedRequest = this.convertData(request);
  //                 return next.handle(this.addToken(clonedRequest, token.token));
  //             }));

  //     } else {
  //         return this.refreshTokenSubject.pipe(
  //             filter(token => token != null),
  //             take(1),
  //             switchMap(jwt => {
  //                 let clonedRequest = this.convertData(request);
  //                 return next.handle(this.addToken(clonedRequest, jwt.token));
  //             }));
  //     }
  // }
  handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler,
    isGuestUser?: boolean
  ) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      let temp: string;
      return this.authService.refreshToken().pipe(
        // switchMap((token: any) => {
        //   this.isRefreshing = false;
        //   this.refreshTokenSubject.next(token);
        //   return next.handle(this.addToken(request, token.token));
        // }),
        // catchError(() => {
        //   // this.authService.loggeOut();
        //   this.router.navigate(['/logout'])
        //   return throwError(new AppError(400, "Session Timeout!"));
        // }));

        switchMap((token: any) => {
          // this.refreshTokenSubject.next(token);
          this.refreshTokenSubject.next(token.token?token.token:token);
          let clonedRequest = this.convertData(request);
         
        return next.handle(this.addToken(clonedRequest, token.token?token.token:token)).pipe(map((res) => {
          return this.handleResponse(res)
        }));
        }),
        catchError(async () => {
          const isLoggedOut = await this.authService.loggeOut();
          if (isLoggedOut &&  this.router) {
            this.router.navigate(["login"]);
            
          }
          return throwError(new AppError(400, "Session Timeout!"));
        }),
        finalize(() => {
          this.isRefreshing = false;
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((jwt) => jwt !== null),
        take(1),
        mergeMap((jwt) => {
          console.log("JWT Token:", jwt.token);
          this.refreshTokenSubject.next(jwt.token?jwt.token:jwt);
          let clonedRequest = this.convertData(request);
     
        return next.handle(this.addToken(clonedRequest,jwt.token?jwt.token:jwt)).pipe(map((res) => {
          return this.handleResponse(res)
        }));
        })
      );
    }
  }

  addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  ParseIfJSON(text: any) {
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  }

  convertData(req) {
    let clonedRequest;
    if (req.url.includes("/admin/login")) {
      clonedRequest = req.clone({
        setHeaders: {
          source: "1",
        },
        url: `/api${req.url}`,
      });
    } else if (req.url.includes("bundels/modules.json") || (req.url.includes("assets") && req.url.includes("."))) {
      clonedRequest = req.clone();
    } else if (
      window["config"] &&
      window["config"].coreURL &&
      req.url.includes(window["config"].coreURL)
    ) {
      clonedRequest = req.clone();
    } else if ((req.url.includes("CPAPI") || req.url.includes("SharedSetupApi") || req.url.includes("ApiMapper")) && !req.url.includes("GetApiMapperBySiteId") && !req.url.includes("GetDataSourceListBySiteId") && !req.url.includes("GetApiMapperTransactionHistory")) {
      clonedRequest = req.clone();
    } else {
      clonedRequest = req.clone({
        setHeaders: {
          siteId: this._siteId + "",
          source: "1",
          "DCMS-ApiKey": String(
            window["config"].rateKey || "B8524FE6151c40B38E69F5Ac476646EC"
          ),
          Authorization: `bearer ${this.cookieService.get(
            "admin_access_token"
          )}`,
        },
      });
      clonedRequest.url = `/api${req.url}`;
      clonedRequest.urlWithParams = `/api${req.url}`;
    }
    return clonedRequest;
  }
  handleResponse(res) {
    let clonedData;

    if (res.type == HttpEventType.Response) {
      if (typeof res.body == "string" && res.body.length > 0) {
        clonedData = res.clone({ body: JSON.parse(res.body).content });
      }
      if (res.body && res.body.content) {
        clonedData = res.clone({ body: res.body.content });
      }
      else if(res.body){
        clonedData = res.clone({ body: res.body})
      }
      return clonedData;
    } else {
      return res;
    }
  }
  get _siteId() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    return userData
      ? this.authService && this.authService.siteId
        ? this.authService.siteId
        : userData.DefaultSiteInfo && userData.DefaultSiteInfo.siteId
        ? userData.DefaultSiteInfo.siteId
        : 0
      : 0;
  }
}
